import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomerLayout } from '../../components/layouts/CustomerLayout';
import { Card, CardContent } from '../../components/ui/Card';
import { Car, Shield, Heart, Flame, UserCheck, Briefcase } from 'lucide-react';
const insuranceTypes = [{
  id: 'third-party',
  title: 'بیمه شخص ثالث',
  description: 'بیمه اجباری خودرو برای جبران خسارات مالی و جانی',
  icon: Car,
  color: 'text-blue-600',
  bg: 'bg-blue-100'
}, {
  id: 'body',
  title: 'بیمه بدنه',
  description: 'جبران خسارات وارد شده به خودروی شما در حوادث',
  icon: Shield,
  color: 'text-indigo-600',
  bg: 'bg-indigo-100'
}, {
  id: 'health',
  title: 'بیمه درمان تکمیلی',
  description: 'پوشش هزینه‌های پزشکی و بیمارستانی فراتر از بیمه پایه',
  icon: Heart,
  color: 'text-red-600',
  bg: 'bg-red-100'
}, {
  id: 'fire',
  title: 'بیمه آتش‌سوزی',
  description: 'محافظت از منزل و محل کار در برابر آتش‌سوزی و زلزله',
  icon: Flame,
  color: 'text-orange-600',
  bg: 'bg-orange-100'
}, {
  id: 'life',
  title: 'بیمه عمر',
  description: 'سرمایه‌گذاری مطمئن برای آینده و پوشش فوت',
  icon: UserCheck,
  color: 'text-green-600',
  bg: 'bg-green-100'
}, {
  id: 'liability',
  title: 'بیمه مسئولیت',
  description: 'جبران خسارات ناشی از مسئولیت حرفه‌ای و مدنی',
  icon: Briefcase,
  color: 'text-purple-600',
  bg: 'bg-purple-100'
}];
export function InsuranceTypeSelectorPage() {
  const navigate = useNavigate();
  return <CustomerLayout data-id="element-514">
      <div className="space-y-8" data-id="element-515">
        <div className="text-center" data-id="element-516">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-517">انتخاب نوع بیمه</h1>
          <p className="text-gray-500 mt-2" data-id="element-518">
            برای شروع، نوع بیمه مورد نظر خود را انتخاب کنید
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-519">
          {insuranceTypes.map(type => <Card key={type.id} className="cursor-pointer hover:shadow-lg transition-all hover:scale-[1.02] border-2 border-transparent hover:border-primary/10" onClick={() => navigate(`/insurance/buy?type=${type.id}`)} data-id="element-520">
              <CardContent className="p-6 flex flex-col items-center text-center h-full" data-id="element-521">
                <div className={`p-4 rounded-full ${type.bg} ${type.color} mb-4`} data-id="element-522">
                  <type.icon className="h-8 w-8" data-id="element-523" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-524">
                  {type.title}
                </h3>
                <p className="text-sm text-gray-500" data-id="element-525">{type.description}</p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </CustomerLayout>;
}